import {QuerySearchFilterApiDto} from "../../api/model/rest";

export default class WildcardFilter {

	constructor(public readonly value: string) {}

	toQueryJson(columnType: string): QuerySearchFilterApiDto {
		return {
			columnType: columnType,
			operatorType: "WILDCARD",
			propertyName: "",
			values: [this.value]
		}
	}
}

export enum WildcardFilterColumnType {
	LeadJobs = "WILDCARD",
	Materials = "WILDCARD_MATERIAL",
	Assets = "WILDCARD_ASSET",
	Transactions = "WILDCARD_TRANSACTION",
	Bills = "WILDCARD_BILL",
	PartnerBrands = "WILDCARD_PARTNER_BRAND"
}